import api from "./api";

export const winnerService = {
  // ================= PLAYER PENDING WINNERS =================
  getPendingWinners: async () => {
    const response = await api.get("/shop/pending-winners");
    return response.data;
  },

  // ================= PLAYER PAID WINNERS =================
  getPaidWinners: async () => {
    const response = await api.get("/shop/paid-winners");
    return response.data;
  },

  // ================= PLAYER MARK WINNING PAID =================
  markWinningPaid: async (betId) => {
    const response = await api.post("/shop/mark-winning-paid", {
      bet_id: betId,
    });
    return response.data;
  },
};

export default winnerService;